import { html } from 'fxjs/es';
import { getResizedImageUrl } from '../../../../../../../services/MarppleShop/shared/util/getResizedImageUrl.ts';

export const fn = () =>
  html` <div class="app-store-suspended">
    <img
      src="//s3.marpple.co/files/u_1093672/2020/3/original/1798640c13be10b736431f170d101e632e0a9c0e2ceb1e6.png"
    />
    <p>해당 마플샵은 운영이 중지되었습니다.</p>
  </div>`;

export const makeStudioSuspendTmpl = () => {
  const component = 'app-studio-suspended';

  return html`
    <div class="${component}">
      <img
        class="${component}__image"
        src="${getResizedImageUrl({
          url: '//s3.marpple.co/files/u_1165777/2025/2/original/8424f9a506918e384d72c7bc54ec5e948cfc893f1.png',
          width: '320',
          format: 'webp',
        })}"
        alt=""
      />
      <p class="${component}__title" style="margin-bottom: 16px;">
        해당 마플샵은 아래와 같은 사유로<br />
        운영이 중지되었습니다.
      </p>

      <div class="${component}__description" style="margin-bottom: 8px;">
        <span>
          ① 부적절한 콘텐츠 사용: 사회적, 윤리적으로 부적절한 콘텐츠 등 을 등록하거나 공개 및 판매한 경우
        </span>
        <span>
          ② 관계 법령 위반 : "정보통신망법" 및 "저작권법", “표시광고법” 등 관계 법령 등 을 위반한 경우
        </span>
        <span>
          ③ 플랫폼 정책 위반 : 만 14세 미만 사용자 운영, 명의 도용 등 플랫폼 약관 혹은 정책을 위반한 경우
        </span>
      </div>

      <div class="${component}__description-bottom">
        운영 중지 해제를 요청하려면 해당 정보(스토어명 / 이메일/ 성함 / 연락처)를 포함하여<br />
        고객센터(partner@marppleshop.com)로 문의해 주시기 바랍니다.
      </div>
    </div>
  `;
};
